import _merge from 'lodash/merge';
import _forEach from 'lodash/forEach';
import _find from 'lodash/find';

/**
 * @class
 *
 * @description
 * Класс для работы с параметрами
 */
var Properties = function(properties, characteristics) {
  var self = this;

  _merge(self.getProperties(), self._build(properties, characteristics));

  return self;
};

/**
 * @private
 */
Properties.prototype.getProperties = function() {
  var self = this;
  var _properties;

  _properties = self;

  return _properties;
};

/**
 * @private
 */
Properties.prototype._build = function(properties, characteristics) {
  var self = this;
  var _properties;

  _properties = _forEach(properties, function(_property) {
    _property.characteristics = [];

    return _property;
  });

  _forEach(characteristics, function(_characteristic) {
    var _property = _find(_properties, { id: _characteristic.property_id });

    if (!_property) {
      return;
    }

    _property.characteristics.push(_characteristic);
  });

  return _properties;
};

export default Properties;
